import sassToJs from 'sass-to-js';


const CONFIG = {
    debug: false,
    pseudoEl: '::before',
    cssProperty: 'content',
};

/**
 * Parse and export shared data in scss
 * @param {HTMLElement} el - Node that will be our bridge between sass and js
 * @return {Object} An object containing the scss shared variables
 */
export default function scssData(el) {
    return sassToJs(el, CONFIG);
}
